import React, { useState } from 'react'

import { CloseIcon } from 'components'
import Modal from 'components/AuthModal/components/Modal'
import Overlay from 'components/AuthModal/components/Overlay'

import { OVERLAY } from 'components/AuthModal/styles'
import ActiveUsers from 'pages/admin/components/ActiveUsers'
import MatchConfirmationModal from 'pages/admin/AdminUser/MatchConfirmationModal'

const MatchModal = ({ user, show, onClose }) => {
  const [profile, setProfile] = useState(null)

  return (
    <Overlay show={show} className={OVERLAY} preventEscBackdropClose={true} onClose={onClose}>
      <Modal innerClassName="w-screen max-w-auto px-10 rounded-t-3xl max-w-auto overflow-y-scroll">
        <div className="relative w-full p-5 max-w-full md:p-7 md:py-5 bg-white">
          <button className="bg-transparent text-black absolute top-3 right-4" onClick={onClose}>
            <CloseIcon className="w-4 h-4" />
          </button>
          <div className="text-black text-center text-5xl font-bold font-ownersWide mb-10 underline">
            Queue upcoming match
          </div>
          <div className="overflow-y-scroll" style={{ height: '80vh' }}>
            <ActiveUsers
              action={{
                title: 'Match',
                cta: 'Add',
                onAction: setProfile,
              }}
            />
          </div>
        </div>
        {profile && (
          <MatchConfirmationModal
            user={user}
            profile={profile}
            show={true}
            onClose={() => setProfile(null)}
          />
        )}
      </Modal>
    </Overlay>
  )
}

export default MatchModal
